import { url } from '../../static/env';

export function supportToken() { return localStorage.getItem('support_token') || ''; }
export async function supportRequest(path, options = {}) {
  const response = await fetch(`${url}/support/${path}`, {
    ...options,
    headers: { ...(options.body instanceof FormData ? {} : { 'Content-Type': 'application/json' }),
      Authorization: `Bearer ${supportToken()}`, ...options.headers },
  });
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.error || `Ошибка сервера (${response.status})`);
  }
  return options.blob ? response.blob() : response.json();
}
export async function downloadSupportFile(message) {
  const blob = await supportRequest(`files/${message.id}`, { blob: true });
  const href = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = href; link.download = message.filename; link.click();
  setTimeout(() => URL.revokeObjectURL(href), 1000);
}
